import { useQuery } from '@apollo/client';
import { Loader } from '@gasbuddy/react-components';
import loadable from '@loadable/component';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import buildTranslatedCMSDataObject from '../../../lib/utils/buildTranslatedCMSDataObject';
import { SUPPORTED_LANGUAGES } from '../../constants';
import PageType from '../../constants/pageType';
import PageLayout from '../PageLayout/PageLayout';
import { GET_PAGE } from './CMSPage.gql';

const AboutUsTemplate = loadable(() => import('../AboutUsPage'));
const LPTemplate1 = loadable(() => import('../LandingPageTemplate1'));
const LPTemplate2 = loadable(() => import('../LandingPageTemplate2'));

function CMSPage() {
  const { t, i18n } = useTranslation('');
  const { pathname } = useLocation();
  const { data, error, loading } = useQuery(GET_PAGE, {
    variables: {
      url: pathname.substring(1),
    },
  });
  if (error) {
    throw new Error(t('errors.errorLoadingPage', { ns: 'miscellaneous' }));
  }

  const page = buildTranslatedCMSDataObject(data?.page, i18n.language, ['faqs']);
  if (i18n.language === SUPPORTED_LANGUAGES.FRENCH && data?.page?.locales?.fr?.faqs?.title) {
    // Just the title of the FAQs section has separate translation
    page.faqs.title = data?.page?.locales?.fr.faqs.title || page.faqs.title;
  }

  if (loading) {
    return (
      <Loader />
    );
  }

  let pageContent;

  if (page?.type === PageType.About) {
    pageContent = (
      <AboutUsTemplate page={page} />
    );
  } else if (page?.type === PageType.Generic) {
    pageContent = (
      <LPTemplate2 page={page} />
    );
  } else {
    pageContent = (
      <LPTemplate1 page={page} />
    );
  }

  if (page?.partnerMobileLogo || page?.partnerLogo) {
    return pageContent;
  }

  return (
    <PageLayout>
      {pageContent}
    </PageLayout>
  );
}

export default CMSPage;
